import { render, staticRenderFns } from "./textArea.vue?vue&type=template&id=454af7de&scoped=true&"
import script from "./textArea.vue?vue&type=script&lang=js&"
export * from "./textArea.vue?vue&type=script&lang=js&"
import style0 from "./textArea.vue?vue&type=style&index=0&id=454af7de&prod&lang=scss&scoped=true&"
import style1 from "./textArea.vue?vue&type=style&index=1&id=454af7de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454af7de",
  null
  
)

export default component.exports